import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IDanhSachTroCapActionTypes } from "../../action-types/tro-cap/IDanhSachTroCapActions";

import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachTroCapReducer } from "../../reducer-model/tro-cap/IDanhSachTroCapReducer";

const iniState: IDanhSachTroCapReducer = {
  status: eReducerStatusBase.is_not_initialization,
  troCaps: [],
  displayMode: getDefaultDisplayMode(),
  troCapIds: [],
  doiTuongID: 0,
  typeStatus: 0,
};
export const danhSachTroCapReducer = (
  state: IDanhSachTroCapReducer = iniState,
  action: IDanhSachTroCapActionTypes
): IDanhSachTroCapReducer => {
  switch (action.type) {
    case "DANH_SACH_TRO_CAP_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DANH_SACH_TRO_CAP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        troCaps: action.payload,
      };
    case "DANH_SACH_TRO_CAP_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_SACH_TRO_CAP_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DANH_SACH_TRO_CAP_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        troCapIds: [],
        status: eReducerStatusBase.is_need_reload,
      };
    case "DANH_SACH_TRO_CAP_CHANGE_TROCAP_SELECTED_IDS":
      return {
        ...state,
        troCapIds: action.payload,
      };
    case "DANH_SACH_TRO_CAP_CHANGE_DOI_TUONG":
      return {
        ...state,
        doiTuongID: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DANH_SACH_TRO_CAP_CHANGE_TYPE_DISPLAY":
      return {
        ...state,
        typeStatus: action.payload,
      };
    case "DANH_SACH_TRO_CAP_DUYET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DANH_SACH_TRO_CAP_DUYET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        troCapIds: [],
      };
    case "DANH_SACH_TRO_CAP_DUYET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_SACH_TRO_CAP_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };
    case "DANH_SACH_TRO_CAP_HUY_DUYET_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DANH_SACH_TRO_CAP_HUY_DUYET_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        troCapIds: [],
      };
    case "DANH_SACH_TRO_CAP_HUY_DUYET_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
